import React from 'react';
import { useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';

import getAllHomePageSettings from './getAllHomePageSettings.graphql';

import Page from '../../../components/Page/Page';
import SignupGrid from '../../../components/Home/SignupGrid/SignupGrid';
import { HomeProvider } from '../../context/homeContext';
import { getDynamicTitleByLocale } from '../../../helpers/getDynamicTitle';
import useQueryResponse from '../../../lib/hooks/useQueryResponse';
import s from './Partner.css';

function Partner({ data }) {
  const currentLocale = useSelector((state) => state?.intl?.locale);

  const { loading, data: homePageData } = useQueryResponse({ query: getAllHomePageSettings, fetchPolicy: 'cache-first' });

  const getEditStaticPage = data?.getEditStaticPage;
  const staticLoading = data?.loading;

  const homeSettings = {};
  const dynamicHomePageSettings = [];

  if (!loading && homePageData?.getAllHomePageSettings?.homePageData) {
    homePageData?.getAllHomePageSettings?.homePageData.forEach((item) => {
      if (Array.isArray(item?.dynamicHomePageSettings)) {
        item.dynamicHomePageSettings.forEach((o) => {
          const newItem = Object.assign({}, o, { name: item?.name });
          dynamicHomePageSettings.push(newItem);
        });
      }
      homeSettings[item.name] = item.value;
    });
  }

  const pageBanner = getEditStaticPage?.result?.pageBanner;

  const dynamicStaticContent = getDynamicTitleByLocale({
    dynamicHomePageSettings: getEditStaticPage?.result?.dynamicStaticContent,
    locale: currentLocale,
  });

  const content =
    dynamicStaticContent?.[0]?.content || getEditStaticPage?.result?.content;

  return (
    <>
      {!loading && !staticLoading && (
        <div className='contentPageWrapper'>
          <HomeProvider value={homeSettings}>
            <div className={s.homeBanner} />
            <Page html={content} pageBanner={pageBanner} />
            <div className={s.staticContentPreviewSpace}>
              <SignupGrid
                dynamicHomePageSettings={dynamicHomePageSettings}
                currentLocale={currentLocale}
              />
            </div>
          </HomeProvider>
        </div>
      )}
    </>
  );
}

export default withStyles(s)(Partner);
